import React from "react";
import { Droplets, Clock } from "lucide-react";

export const DayGuideView = ({ day, target, showTotals, testid = "guide-day" }) => (
  <div data-testid={testid}>
    {showTotals && day.totals && (
      <div style={{ fontSize: 12, color: "#a3a3a3", marginBottom: 10 }} data-testid={`${testid}-totals`}>
        Total propuesto: <b style={{ color: "#fff" }}>{day.totals.kcal} kcal</b> · P {day.totals.protein_g} g · C {day.totals.carbs_g} g · G {day.totals.fat_g} g
        {target && <span> — objetivo {target.kcal} kcal · P {target.protein_g} · C {target.carbs_g} · G {target.fat_g}</span>}
      </div>
    )}
    {day.meals.map((m, i) => (
      <div key={i} style={{ borderLeft: "2px solid var(--qv-red, #E11D2E)", padding: "6px 0 6px 12px", marginBottom: 10 }} data-testid={`${testid}-meal-${i}`}>
        <div style={{ display: "flex", gap: 8, alignItems: "center", fontWeight: 700, fontSize: 14 }}><Clock size={13} /> {m.time || "—"} · {m.name}</div>
        {m.goal && <div style={{ fontSize: 12, color: "#a3a3a3", margin: "2px 0 4px" }}>{m.goal}</div>}
        <ul style={{ margin: "4px 0", paddingLeft: 18, fontSize: 13 }}>
          {m.foods.map((f, j) => <li key={j}>{f.food}{f.qty ? ` — ${f.qty}` : ""}{showTotals ? <span style={{ color: "#737373" }}> ({f.kcal} kcal · P{f.protein_g} C{f.carbs_g} G{f.fat_g})</span> : null}</li>)}
        </ul>
        {m.alternatives?.length > 0 && <div style={{ fontSize: 12, color: "#a3a3a3" }}>Alternativas: {m.alternatives.join(" · ")}</div>}
      </div>
    ))}
    {day.hydration?.length > 0 && (
      <div style={{ fontSize: 13, marginTop: 6 }} data-testid={`${testid}-hydration`}>
        <div style={{ display: "flex", gap: 6, alignItems: "center", fontWeight: 700 }}><Droplets size={13} /> Hidratación</div>
        <ul style={{ margin: "4px 0", paddingLeft: 18 }}>{day.hydration.map((h, i) => <li key={i}>{h}</li>)}</ul>
      </div>
    )}
    {day.post_session && <div style={{ fontSize: 13, marginTop: 6 }} data-testid={`${testid}-post`}><b>Después de entrenar o jugar:</b> {day.post_session}</div>}
  </div>
);
